module.exports = __webpack_public_path__ + "media/images/logoxuntaconselleria-b70d64721f8b75f98e7f3999d8b1c156.png";